export const URI_KEY = {
  ORDERS_STATE: "order-state",
  DELIVERY_CLASSES: "delivery_classes",
  /** 새로운 서비스 유형 필터 (deliveryClass + forwardingOrg 조합) */
  SHIPPING_SERVICES: "shipping_services",
  MOVEMENT: "movement",
  STATION_CODE: "station_code",
  PRINT: "print",
  SHIPPING_PLACES: "shipping_place",
  SELECTED_CLIENTS: "selected_clients",
} as const
